import '../../styles/registration.css';

export const NewPasswordPopperItem = ({
    item,
}) => {
    return (
        <div className={"menuItem"} disabled={true}>
            <div className={"flexRow"}>
                {item.isActive
                    ? svgObject.checkedApproved
                    : svgObject.checkedNotApproved}
                <div className={"popperText"}>{item.text}</div>
            </div>
        </div>
    );
};

const svgObject = {
    checkedApproved: <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.54534 8.75836L9.76567 4.40871C10.0781 4.08628 10.0781 3.56388 9.76555 3.24164C9.45297 2.91958 8.94601 2.91933 8.63331 3.24164L4.97936 7.00784L3.36666 5.34559C3.0541 5.02341 2.54718 5.02341 2.23448 5.34571C1.92184 5.66795 1.92184 6.19054 2.23448 6.51272L4.41304 8.75836C4.72586 9.08055 5.23282 9.08055 5.54534 8.75836Z"
            fill="#40B8E9"
        />
    </svg>,
    checkedNotApproved:
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="#C1C7CD"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.54534 8.75836L9.76567 4.40871C10.0781 4.08628 10.0781 3.56388 9.76555 3.24164C9.45297 2.91958 8.94601 2.91933 8.63331 3.24164L4.97936 7.00784L3.36666 5.34559C3.0541 5.02341 2.54718 5.02341 2.23448 5.34571C1.92184 5.66795 1.92184 6.19054 2.23448 6.51272L4.41304 8.75836C4.72586 9.08055 5.23282 9.08055 5.54534 8.75836Z"
                fill="#C1C7CD"
            />
        </svg>
};